module.exports = __webpack_public_path__ + "img/LandTown.f3be92fa.png";